export default {
  psicologos: 'CRP',
  nutricionistas: 'CRN',
  orientacaofisica: 'CREF',
} as Record<string, string>;
